import moment from 'moment';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import messages from '../../../intl/messages';
import { Route } from './Route';
import { AppState } from '../../../store/model';
import { isSaviSelectIntl } from '../../../store/reducers/itinerary/selectors';
import { connect } from 'react-redux';

interface OwnProps {
  checkIn: Date;
  checkOut: Date;
}

interface StateProps {
  isSaviSelectIntl: boolean;
}

interface HotelRouteProps extends OwnProps, InjectedIntlProps, StateProps {}

const HotelRouteBase: FunctionComponent<HotelRouteProps> = ({
  intl: { formatMessage, formatTime },
  checkIn,
  checkOut,
  isSaviSelectIntl,
}) => {
  const dateFormat = isSaviSelectIntl ? 'ddd, D MMM' : 'ddd D MMM';

  return (
    <Route
      from={{
        label: formatMessage(messages.hotel.startLabelText),
        mainText: formatTime(checkIn),
        secondaryText: moment(checkIn).format(dateFormat),
      }}
      to={{
        label: formatMessage(messages.hotel.endLabelText),
        mainText: formatTime(checkOut),
        secondaryText: moment(checkOut).format(dateFormat),
      }}
      type="Hotel"
    />
  );
};

const mapStateToProps = (
  state: AppState,
) => {
  return {
    isSaviSelectIntl: isSaviSelectIntl(state),
  }
};

const enhance = compose<HotelRouteProps, OwnProps>(
  pure,
  injectIntl,
  connect(mapStateToProps)
);

export const HotelRoute = enhance(HotelRouteBase);

HotelRoute.displayName = 'HotelRoute';
